<template>
  <div
    :style="section.styles.cssVariables.value"
    class="bg-(bg-default) md:text-(fg-onemphasis) white"
    :class="[
      section.styles.spacerTop.value,
      section.styles.spacerBottom.value,
    ]"
  >
    <div :class="`relative ${section.data?.value.isFullScreen ? '' : 'container'}`">
      <div
        class="min-w-full"
        :class="{
          'min-h-[100vh] bg-(fg-muted)': !section.data?.value.image[section.lang.value]?.source,
        }"
      >
        <img
          v-if="section.data?.value.image[section.lang.value]?.source"
          :src="`${useRuntimeConfig().public.imagekit}${useRuntimeConfig().public.imagekit ? '/tr:w-1920,c-at_max/' : ''}${section.data?.value.image[section.lang.value]?.source}`"
          class="w-full max-h-[100vh] object-cover"
          :alt="eventTitle"
        >
      </div>
      <div
        :class="`py-4 md:absolute md:top-0 md:left-0 w-full h-full flex items-center ${section.data?.value.hasOverlay ? 'md:bg-black/20' : ''}`"
      >
        <div
          class="container container--narrow"
          :class="[
            section.styles.textAlignment.value,
          ]"
        >
          <span
            v-if="section.data?.value.shownElements?.text"
            class="text-(fg-default) md:text-(fg-onemphasis)"
            v-html="sanitize(section.data?.value.text[section.lang.value]?.content)"
          />
          <button
            v-if="section.data?.value.shownElements?.ctaButton"
            v-animated-scroll-to="`#section-${section.ctaButton?.value?.targetSection}`"
            type="button"
            class="page-button mt-8"
          >
            <span v-html="sanitize(section.ctaButton?.value?.[section.lang.value]?.text)" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const section = usePageSection(props);
const eventTitle = inject('eventTitle');
</script>
